"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OmniMenu = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const transform_1 = tslib_1.__importDefault(require("iconista/lib/react/tabler/transform"));
const typography_1 = tslib_1.__importDefault(require("iconista/lib/react/tabler/typography"));
const TurnIntoIcon = (props) => (React.createElement(transform_1.default, { width: 16, height: 16, ...props }));
const FormatIcon = (props) => (React.createElement(typography_1.default, { width: 16, height: 16, ...props }));
class OmniMenu {
    constructor(mutxt) {
        this.mutxt = mutxt;
    }
    start() {
        return () => { };
    }
    build() {
        const mutxt = this.mutxt;
        const voidMenu = mutxt.voids.menu;
        const blockMenu = mutxt.block.menu;
        const inlineMenu = mutxt.inline.menu;
        const hasSelection = mutxt.api.hasSelection();
        const formatChildren = [inlineMenu.menuFmtCommon(), inlineMenu.menuFmtTechnical()];
        if (hasSelection) {
            formatChildren.push(inlineMenu.menuAnnotations({ anchorFromSelection: true }), inlineMenu.menuModify());
        }
        return {
            name: 'Quick actions',
            minWidth: 320,
            children: [
                voidMenu.itemFile({ anchorFromCaret: true }),
                voidMenu.itemEmbed({ anchorFromCaret: true }),
                voidMenu.itemHr(),
                voidMenu.itemToc(),
                { name: 'sep-turn', sep: true },
                {
                    name: 'Turn into',
                    text: 'transform convert change block format type',
                    icon: () => React.createElement(TurnIntoIcon, null),
                    children: [blockMenu.menuBlocks(), blockMenu.menuHeadings(), blockMenu.menuLists(), blockMenu.menuLayout()],
                },
                {
                    name: 'Format',
                    text: 'style mark inline formatting',
                    icon: () => React.createElement(FormatIcon, null),
                    children: formatChildren,
                },
                { name: 'sep-doc', sep: true },
                mutxt.docMenu.build(),
            ],
        };
    }
}
exports.OmniMenu = OmniMenu;
